type TextBoxProps = {
  text: string;
  bgColor?: string;
  borderColor?: string;
  fontColor?: string;
  fontSize?: string;
  fontWeight?: string;
  hoverBgColor?: string;
  hoverFontColor?: string;
  hoverBorderColor?: string;
  width?: string;
  height?: string;
  radius?: number;
};

const TextBox = ({
  text,
  bgColor = '',
  borderColor = '',
  fontColor = 'text-BADBlue',
  fontSize = 'text-base font-bold',
  fontWeight = 'font-normal',
  width = 'w-[100%]',
  height = 'h-auto',
  radius = 6,
}: TextBoxProps) => {
  const texts = text.split('<br>');
  const border = borderColor === '' ? '' : `border ${borderColor}`;
  return (
    <>
      <div
        className={`${bgColor} ${border} ${fontSize} ${fontWeight} ${fontColor} ${width} ${height} font-normal rounded-[${radius}px] py-2`}
      >
        {texts.map((line, index) => (
          <p
            key={index}
            className="px-2 break-words whitespace-normal text-center w-full"
          >
            {line}
          </p>
        ))}
      </div>
    </>
  );
};

export default TextBox;
